module.exports = __webpack_public_path__ + "static/index/img/baikal-508.586444e6.jpg";